import React from 'react'
import classNames from 'classnames'

import MetaColorMode from './ColorMode'
import MetaSupport from './Support'

type MetabarWrapperProps = {
  children?: React.ReactNode
  className?: string
}

export function MetabarWrapper({ className, children }: MetabarWrapperProps) {
  return (
    <div
      className={classNames(
        'flexbox flexbox-column flexbox-align-center height-full',
        className
      )}
    >
      <div style={{ width: 32 }} className="flexbox-grow">
        {children}
      </div>
      <div className="flexbox-no-grow">
        <MetaColorMode />
        <MetaSupport />
      </div>
    </div>
  )
}

export function MetabarSeparator() {
  return (
    <div
      className="margin-vertical-normal background-shade-45 radius-normal"
      style={{ height: 2 }}
    />
  )
}
